import { find } from 'lodash'
import countries from './countries.json'

const POSITION_ACCEPTED_COUNTRIES = [
  'AR',
  'AT',
  'AU',
  'BE',
  'BR',
  'CA',
  'CH',
  'CL',
  'CN',
  'CZ',
  'DE',
  'DK',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HU',
  'HR',
  'HK',
  'IE',
  'IL',
  'IT',
  'JP',
  'KR',
  'LU',
  'MX',
  'NL',
  'NO',
  'PE',
  'PL',
  'PT',
  'RO',
  'RU',
  'SE',
  'SG',
  'US',
]

const getAcceptedCountries = (arrayAccepted) => {
  if (arrayAccepted && arrayAccepted.length) {
    return arrayAccepted.map((countryCode) => find(countries.countries.country, { countryCode }))
  }
  return countries.countries.country
}

export const positionAcceptedCountries = getAcceptedCountries(POSITION_ACCEPTED_COUNTRIES)
export const userAcceptedCountries = getAcceptedCountries()
export const allCountries = getAcceptedCountries()
